import React, { useState, useEffect } from "react";
import axios from "axios";
import axiosInstance from "../../../axiosInstance";
import Swal from "sweetalert2"; // Import SweetAlert2
import withReactContent from "sweetalert2-react-content"; // Import React components for SweetAlert2

import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import LoadingTable from "../../components/LoadingTable";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

const userTypeOptions = [
  { value: "", label: "All User Types" },
  { value: "0", label: "Admin" },
  { value: "2", label: "Job Seeker" },
  { value: "1,3", label: "Recruiter" },
];

const getUserTypeLabel = (type) => {
  const normalizedType = String(type);

  if (normalizedType === "0") {
    return "Admin";
  }

  if (normalizedType === "2") {
    return "Job Seeker";
  }

  if (normalizedType === "1" || normalizedType === "3") {
    return "Recruiter";
  }

  return "User";
};

function AllUser() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [userTypeFilter, setUserTypeFilter] = useState("");
  const [passwordModalUser, setPasswordModalUser] = useState(null);
  const [passwordForm, setPasswordForm] = useState({
    password: "",
    confirm_password: "",
  });
  const [passwordSaving, setPasswordSaving] = useState(false);

  const getEditProfilePath = (user) => {
    const type = Number(user?.type);

    if (type === 2) {
      return `/admin/user/${user._id}/job-seeker-profile`;
    }

    if (type === 1) {
      return `/admin/user/${user._id}/vendor-profile`;
    }

    if (type === 3) {
      return `/admin/user/${user._id}/hospital-profile`;
    }

    return `/user/${user._id}`;
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: String(currentPage),
        limit: String(limit),
        search: searchTerm,
      });

      if (userTypeFilter) {
        params.set("type", userTypeFilter);
      }

      const response = await axiosInstance.get(
        `/admin/all-user?${params.toString()}`
      );
      setData(response.data.users || []);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit, userTypeFilter]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Function to handle delete
  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-popup", // Add a class to the entire dialog
        confirmButton: "btn-danger", // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance
          .delete(`/admin/delete-rating/${categoryId}`)
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Deleting Rating success!");
          })
          .catch((error) => {
            console.error("Error deleting data:", error);
            toast.error("Error deleting data");
          });
      }
    });
  };

  const handleStatusChange = (StatusId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-user/${StatusId}`, {
        status: newStatus,
      });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Status Updated success!");
    } catch (error) {
      console.error("Error updating rating status:", error);
      setLoading(false);
    }
  };

  const handleVerifyChange = (StatusId) => async (event) => {
    const newStatus = event.target.value;
    setLoading(true);

    try {
      await axiosInstance.put(`/admin/update-user-verify/${StatusId}`, {
        status: newStatus,
      });
      setLoading(false);
      fetchData(currentPage);
      toast.success("Verification Updated success!");
    } catch (error) {
      console.error("Error updating rating status:", error);
      setLoading(false);
    }
  };

  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1);
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    fetchData(currentPage);
  };

  const openPasswordModal = (user) => {
    setPasswordModalUser(user);
    setPasswordForm({
      password: "",
      confirm_password: "",
    });
  };

  const closePasswordModal = () => {
    if (passwordSaving) {
      return;
    }

    setPasswordModalUser(null);
    setPasswordForm({
      password: "",
      confirm_password: "",
    });
  };

  const handlePasswordInputChange = (event) => {
    const { name, value } = event.target;
    setPasswordForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();

    if (!passwordModalUser?._id) {
      toast.error("User not found");
      return;
    }

    if (!passwordForm.password || !passwordForm.confirm_password) {
      toast.error("Please enter password and confirm password");
      return;
    }

    if (passwordForm.password !== passwordForm.confirm_password) {
      toast.error("Password and confirm password do not match");
      return;
    }

    try {
      setPasswordSaving(true);
      await axiosInstance.put(`/admin/update-user-details/${passwordModalUser._id}`, {
        password: passwordForm.password,
        confirm_password: passwordForm.confirm_password,
      });
      toast.success("Password changed successfully");
      setPasswordModalUser(null);
      setPasswordForm({
        password: "",
        confirm_password: "",
      });
    } catch (error) {
      console.error("Error changing password:", error);
      toast.error(
        error?.response?.data?.message || "Failed to change password"
      );
    } finally {
      setPasswordSaving(false);
    }
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> All Users</h1>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="table-responsive py-4" style={{ overflowX: "auto" }}>
            {loading ? (
              <LoadingTable />
            ) : (
              <>
                <div className="datatable-top d-flex flex-wrap gap-3 align-items-center justify-content-between">
                  <div className="datatable-dropdown">
                    <label>
                      <select
                        className="datatable-selector"
                        value={limit}
                        onChange={(e) => {
                          setlimit(parseInt(e.target.value, 10));
                          setCurrentPage(1); // Reset current page to 1 when the limit changes
                        }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}
                      entries per page
                    </label>
                  </div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <select
                      className="form-select"
                      style={{ minWidth: 170 }}
                      value={userTypeFilter}
                      onChange={(event) => {
                        setCurrentPage(1);
                        setUserTypeFilter(event.target.value);
                      }}
                    >
                      {userTypeOptions.map((option) => (
                        <option key={option.value || "all"} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}>
                      {" "}
                      Search
                    </button>
                  </div>
                </div>

                <table className="table table-flush align-middle" style={{ minWidth: 1120, tableLayout: "fixed" }}>
                  <thead>
                    <tr>
                      <th style={{ width: 180 }}>ID</th>
                      <th style={{ width: 170 }}>Full Name</th>
                      <th style={{ width: 240 }}>Email</th>
                      <th style={{ width: 140 }}>Phone</th>
                      <th style={{ width: 130 }}>User Type</th>
                      <th style={{ width: 140 }}>Status</th>
                      <th style={{ width: 160 }}>Verification</th>
                      <th style={{ width: 160 }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row) => (
                      <tr key={row._id}>
                        <td className="text-break">{row._id}</td>
                        <td className="text-break">{row.username}</td>
                        <td className="text-break"> {row.email} </td>
                        <td> {row.phone} </td>
                        <td>
                          <span className="badge bg-info text-dark">
                            {getUserTypeLabel(row.type)}
                          </span>
                        </td>
                        <td>
                          <select
                            style={{ width: "fit-content" }}
                            className={`form-control select ${
                              row.status == 0
                                ? "text-white btn-danger"
                                : "text-white btn-success"
                            }`}
                            value={row.status}
                            name="status"
                            onChange={handleStatusChange(row._id)}
                          >
                            <option value="1">Active</option>
                            <option value="0">Inactive </option>
                          </select>

                          <br />
                        </td>
                        <td>
                          <select
                            style={{ width: "fit-content" }}
                            className={`form-control select ${
                              row.verified === 0
                                ? "text-white btn-danger" // For row.verified === 0, apply text-white and btn-danger
                                : row.verified === 2
                                ? "text-white btn-warning" // For row.verified === 2, apply text-white and btn-warning
                                : "text-white btn-success" // For row.verified === 1 or any other value, apply text-white and btn-success
                            }`}
                            value={row.verified}
                            name="status"
                            onChange={handleVerifyChange(row._id)}
                          >
                            <option value="1">Verified</option>
                            <option value="2">Pending</option>
                            <option value="0">unverified </option>
                          </select>

                          <br />
                        </td>
                        <td>
                          <div className="d-grid gap-2">
                            <Link
                              className="btn btn-secondary btn-sm"
                              to={getEditProfilePath(row)}
                            >
                              Edit
                            </Link>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={() => openPasswordModal(row)}
                            >
                              Password
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="datatable-bottom">
                  <div className="datatable-info"> </div>
                  <nav className="datatable-pagination">
                    <ul class="datatable-pagination-list">
                      <li
                        className={`datatable-pagination-list-item ${
                          currentPage === 1
                            ? "datatable-hidden"
                            : "datatable-active"
                        }`}
                      >
                        <button
                          data-page="1"
                          class="datatable-pagination-list-item-link"
                          onClick={handlePreviousPage}
                          disabled={loading || currentPage === 1}
                          aria-label="Page 1"
                        >
                          ‹
                        </button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">
                          Showing Page{" "}
                          <strong>
                            Showing Page {currentPage} of {totalPages}
                          </strong>{" "}
                        </div>
                      </li>
                      <li
                        className={`datatable-pagination-list-item ${
                          currentPage === totalPages
                            ? "datatable-hidden"
                            : "datatable-active"
                        }`}
                      >
                        <button
                          data-page="2"
                          class="datatable-pagination-list-item-link"
                          aria-label="Page 2"
                          onClick={handleNextPage}
                          disabled={loading || currentPage === totalPages}
                        >
                          {" "}
                          {loading ? "Loading..." : "›"}{" "}
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </>
            )}
          </div>
        </div>
      </main>

      {passwordModalUser && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.45)" }}
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form onSubmit={handlePasswordSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">Change Password</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={closePasswordModal}
                    disabled={passwordSaving}
                  ></button>
                </div>
                <div className="modal-body">
                  <p className="mb-3 text-muted">
                    {passwordModalUser.username || passwordModalUser.email}
                  </p>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="new_password">
                      New Password
                    </label>
                    <input
                      type="password"
                      id="new_password"
                      name="password"
                      className="form-control"
                      value={passwordForm.password}
                      onChange={handlePasswordInputChange}
                      placeholder="Enter new password"
                      autoComplete="new-password"
                      disabled={passwordSaving}
                    />
                  </div>

                  <div className="mb-0">
                    <label className="form-label" htmlFor="confirm_new_password">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      id="confirm_new_password"
                      name="confirm_password"
                      className="form-control"
                      value={passwordForm.confirm_password}
                      onChange={handlePasswordInputChange}
                      placeholder="Confirm new password"
                      autoComplete="new-password"
                      disabled={passwordSaving}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={closePasswordModal}
                    disabled={passwordSaving}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={passwordSaving}
                  >
                    {passwordSaving ? "Changing..." : "Change Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AllUser;
